import axios from 'axios';
import AuthService from 'core/auth.service';

axios.interceptors.request.use(
  (config) => {
    const token = AuthService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // The API records this against every database command in the request. Sent only to our
    // own API: a custom header on another site's URL causes a CORS preflight that may fail.
    const clientLocation = AuthService.getClientLocation();
    if (clientLocation && config.url?.startsWith(process.env.REACT_APP_HOST_URL)) {
      config.headers['X-Client-Location'] = clientLocation;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { response } = error;
      if (response.data) {
        const { data } = error.response;
        if (data.statusCode === 401) {
          return Promise.reject(error);
        }
        if (error.response.status === 403) {
          window.location.href = `${process.env.REACT_APP_SUBFOLDER}/access-denied`;
        } else if (data.status === 500 || data.statusCode === 500) {
          window.location.href = `${process.env.REACT_APP_SUBFOLDER}/internal-server/${data.message}`;
        } else if (data.statusCode === 404) {
          window.location.href = `${process.env.REACT_APP_SUBFOLDER}/not-found`;
        } else if (data.status === 408 || data.statusCode === 408) {
          window.location.href = `${process.env.REACT_APP_SUBFOLDER}/request-timed-out`;
        } else {
          return Promise.reject(error);
        }
      }

      if (!response.data) return Promise.reject(error);
    }

    // Reject promise for any other errors (like network errors) that don't have a response object
    return Promise.reject(error);
  },
);
